
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 43"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.966 40.076c.283-4.742 2.057-8.957 5.072-11.985 3.045-3.059 7.181-4.742 11.648-4.742 9.307 0 16.214 6.948 16.883 16.727H2.966zm8.06-28.402c0-4.824 3.924-8.748 8.747-8.748 4.825 0 8.75 3.924 8.75 8.748s-3.925 8.748-8.75 8.748c-4.823 0-8.747-3.924-8.747-8.748zm15.056 9.809c3.223-2.08 5.366-5.696 5.366-9.81C31.448 5.238 26.211 0 19.773 0 13.337 0 8.1 5.237 8.1 11.674c0 4.087 2.117 7.685 5.306 9.772-2.793.93-5.34 2.468-7.442 4.58C2.091 29.919-.027 35.429 0 41.547a1.464 1.464 0 001.463 1.456h36.622a1.463 1.463 0 001.463-1.47c-.043-9.62-5.516-17.336-13.466-20.05z"}})])
          )
        }
      }
    